<div class="menu" ngbDropdown *ngIf="representationAlternatives?.length > 0">
    <p class="representing-name">{{ representingName }}</p>
    <button type="button" class="dropdown-button" ngbDropdownToggle id="representation-dropdown" tabindex="0">
        <span class="material-symbols-rounded" aria-label="Switch organisation" style="font-size: 40px">
            apartment
        </span>
    </button>
    <div ngbDropdownMenu>
        <a
            *ngFor="let representation of representationAlternatives"
            href="#"
            (click)="changeRepresentation(representation); $event.preventDefault()"
            class="dropdown-item"
            [class.active-representation]="representation.id === currentRepresentationId"
        >
            <span>{{ representation.name }}</span>
        </a>
    </div>
</div>
